import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../baseClasses/BaseComponent'; 
import DataSource from '../../../../dao/DataSource/DataSource';
import './PORProjectChildCard.scss';

// TODO: reduce complexity in this component
class PORProjectChildCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
    };
  }
  
  handleProjectRetrieval(project, action, acData, fetchedData) {
    this.setState({ project });
  }

  componentDidMount() {
    super.componentDidMount(this);

    if (!this.props.project.id >= 0) {
      this.projectDataSource = new DataSource('Project', this.props.project.id, { project: {} }, this.handleProjectRetrieval);
      this.projectDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
  }

  handleProjectSelection(select) {
    const { selectProject } = this.props;
    const { project } = this.state;
    if (selectProject) {
      selectProject(project, this.props.project);
    }
  }

  render() {
    let { selected } = this.props;

    let { project } = this.state;
    if (!project) {
      return null;
    }
    
    return (
      <div 
        id={this.props.id}
        className={'por-project-child-card ' + (selected ? ' selected' : '')} 
        onClick={this.handleProjectSelection}
      >
        <div className="project-child-icon-container">
          <div className="project-child-icon" />
          </div>
        <div className="project-child-info">
          <div className="project-child-name">
            {project.name}
          </div>
          <div className="project-child-id">
            {'ID: ' + project.guid}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(PORProjectChildCard);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORNav/PORProjectChildCard/index.js